// Single source of truth for inspection-checklist validation.
//
// A checklist (the `questionaire` array) is valid when it has at least one item
// and every item names an area and has at least one check (the Yes/No questions
// the inspector answers). The area-level prompt and reference photo are optional.
// These items aren't antd Form.Item fields (they live in component state via
// ChecklistItemsEditor), so antd's form validation can't cover them; callers
// run this explicitly before persisting. Used by the property create/edit flow
// and the standalone checklist-template builder so the rules can't drift apart.
//
// Returns a human-readable error string, or null when the checklist is valid.
export const validateChecklistItems = (items) => {
  if (!items?.length) {
    return "Please add at least one checklist item";
  }
  const hasCheck = (q) => (q.checks || []).some((c) => c?.label?.trim());
  if (items.some((q) => !q.area?.trim() || !hasCheck(q))) {
    return "Please give every checklist item an area and at least one check";
  }
  return null;
};
